import { WorkflowTemplate } from "./types";

export const getBadges = (workflow: WorkflowTemplate) => {
  const badges: string[] = [];

  if (workflow.usageCount > 2000) badges.push("Popular");

  const createdDate = new Date(workflow.createdAt);
  const daysOld = (Date.now() - createdDate.getTime()) / (1000 * 60 * 60 * 24);

  if (daysOld < 7) badges.push("New");

  if (workflow.isRecommended) badges.push("Recommended");
  if (workflow.isVerified) badges.push("Verified");

  return badges;
};

export const formatNumber = (num: number) =>
  num > 1000 ? (num / 1000).toFixed(1) + "k" : num.toString();
